
class Payment {
	uuid = null;
	addedOnUsdfDate = null;
	paypalOrderId = null;
}


export { Payment };
